import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import useTranslation from 'customHooks/translate';
import { ACCOUNT_INFO } from 'events/types';
import { getAccountData } from 'services/accounts';

const CompleteProfile = () => {
  const translation = useTranslation();
  const navigate = useNavigate();

  const { data: accountInfo } = useQuery({
    queryKey: [ACCOUNT_INFO],
    queryFn: getAccountData,
    select: (response) => response.data.data,
  });

  if (!accountInfo) {
    return null;
  }

  if (accountInfo.legalDocNumber?.trim()) {
    return null;
  }

  return (
    <div className="mb-4 animate-profile-card-pulse rounded-[8px] border-2 border-[#b8e6c4] bg-white p-3">
      <div className="flex flex-col gap-2.5 font-medium text-[#292d32]">
        <div className="block leading-5">
          {translation.SidebarExpDate.title}
        </div>
        <div className="block text-[13px] leading-[17px] opacity-75">
          {translation.SidebarExpDate.description}
        </div>
        <button
          type="button"
          className="w-full rounded-[6px] bg-[#466afb] px-3 py-2 text-[14px] font-medium leading-4 text-white transition-colors duration-200 hover:bg-[#3558e8]"
          onClick={() => navigate('/profile', { replace: true })}
        >
          {translation.ProfileButton.Profile}
        </button>
      </div>
    </div>
  );
};

export default CompleteProfile;
